"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
var useDialogContentClasses_1 = __importDefault(require("./hooks/useDialogContentClasses"));
var DialogContent = function (_a) {
    var children = _a.children, dialogContentKey = _a.dialogContentKey, contentClasses = _a.contentClasses;
    var dialogContentClasses = (0, useDialogContentClasses_1.default)(contentClasses);
    return (react_1.default.createElement(DialogContent_1.default, { classes: dialogContentClasses, dividers: true, id: "dialog-content-".concat(dialogContentKey) }, children));
};
exports.default = DialogContent;
